export default {
    env: {
        VUE_APP_BASE_API: "https://gatewaypre.cotticoffee.com",
        VUE_APP_MA_BASE_API: "https://gatewaypre.cotticoffee.com",
        VUE_APP_AK: "Prq5qwZBTI4SBxvWvso5srnA7ptHnKZd",
        VUE_APP_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_OL_AK: "Prq5qwZBTI4SBxvWvso5srnA7ptHnKZd",
        VUE_APP_OL_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_APPID: "wx0e61bda0c3c34455",
        VUE_APP_BRAND: "COTTI",
        VUE_APP_DOWNLOAD: "https://mpre.cotticoffee.com",
        VUE_APP_COTTI_UA: "cottiCoffee",
        VUE_APP_AN_SCHEME: "cotticoffee://link",
        VUE_APP_IOS_SCHEME: "cotticoffeelink://"
    },
    tcDevEnv: {
        VUE_APP_BASE_API: "https://gatewaydev.teacat.com",
        VUE_APP_MA_BASE_API: "https://gatewaydev.teacat.com",
        VUE_APP_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_OL_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_OL_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_APPID: "wx0d14b3f957d68955",
        VUE_APP_BRAND: "茶猫",
        VUE_APP_DOWNLOAD: "https://mdev.teacat.com",
        VUE_APP_COTTI_UA: "teacat",
        VUE_APP_AN_SCHEME: "teacat://link",
        VUE_APP_IOS_SCHEME: "teacatlink://"
    },
    cottiDevEnv: {
        VUE_APP_BASE_API: "https://gatewaydev.cotticoffee.com",
        VUE_APP_MA_BASE_API: "https://gatewaydev.cotticoffee.com",      
        VUE_APP_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_OL_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_OL_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_APPID: "wx0e61bda0c3c34455",
        VUE_APP_BRAND: "COTTI",
        VUE_APP_DOWNLOAD: "https://mdev.cotticoffee.com",
        VUE_APP_COTTI_UA: "cottiCoffee",
        VUE_APP_AN_SCHEME: "cotticoffee://link",
        VUE_APP_IOS_SCHEME: "cotticoffeelink://"
    },
    tcTestEnv: {
        VUE_APP_BASE_API: "https://gatewaytest1.teacat.com",
        VUE_APP_MA_BASE_API: "https://gatewaytest1.teacat.com",
        VUE_APP_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_OL_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_OL_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_APPID: "wx0d14b3f957d68955",
        VUE_APP_BRAND: "茶猫",
        VUE_APP_DOWNLOAD: "https://mtest1.teacat.com",
        VUE_APP_COTTI_UA: "teacat",
        VUE_APP_AN_SCHEME: "teacat://link",
        VUE_APP_IOS_SCHEME: "teacatlink://"
    },
    cottiTestEnv: {
        VUE_APP_BASE_API: "https://gatewaytest1.cotticoffee.com",
        VUE_APP_MA_BASE_API: "https://gatewaytest1.cotticoffee.com",
        VUE_APP_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_OL_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_OL_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_APPID: "wx0e61bda0c3c34455",
        VUE_APP_BRAND: "COTTI",
        VUE_APP_DOWNLOAD: "https://mtest1.cotticoffee.com",
        VUE_APP_COTTI_UA: "cottiCoffee",
        VUE_APP_AN_SCHEME: "cotticoffee://link",
        VUE_APP_IOS_SCHEME: "cotticoffeelink://"
    },
    tcPreEnv: {
        VUE_APP_BASE_API: "https://gatewaypre.teacat.com",
        VUE_APP_MA_BASE_API: "https://gatewaypre.teacat.com",
        VUE_APP_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_OL_AK: "vkqHifimu7FvWuqPGAXofmO4vAVwOEPS",
        VUE_APP_OL_SK: "mhOg1l9n4TMAvo5gWl0w36nbUbQBR0u2",
        VUE_APP_APPID: "wx0d14b3f957d68955",
        VUE_APP_BRAND: "茶猫",
        VUE_APP_DOWNLOAD: "https://mpre.teacat.com",
        VUE_APP_COTTI_UA: "teacat",
        VUE_APP_AN_SCHEME: "teacat://link",
        VUE_APP_IOS_SCHEME: "teacatlink://"
    },
    cottiPreEnv: {
        VUE_APP_BASE_API: "https://gatewaypre.cotticoffee.com",
        VUE_APP_MA_BASE_API: "https://gatewaypre.cotticoffee.com",
        VUE_APP_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_OL_AK: "XP1VKh0y5oiMBItGka7OAoEVvrCS8vcF",
        VUE_APP_OL_SK: "QPfm6DXN3Qtcue441VcSv2TMxDEV02Fb",
        VUE_APP_APPID: "wx0e61bda0c3c34455",
        VUE_APP_BRAND: "COTTI",
        VUE_APP_DOWNLOAD: "https://mpre.cotticoffee.com",
        VUE_APP_COTTI_UA: "cottiCoffee",
        VUE_APP_AN_SCHEME: "cotticoffee://link",
        VUE_APP_IOS_SCHEME: "cotticoffeelink://"
    },
    tcProdEnv: {
        VUE_APP_BASE_API: "https://gateway.teacat.com",
        VUE_APP_MA_BASE_API: "https://ma.teacat.com",
        VUE_APP_AK: "7mNuw8pP4VrMFpUPX5L1nwd18Bfy2m8Y",
        VUE_APP_SK: "ABiTQ9rqA1wh03OUz6AbnPRm6IPyQzFu",
        VUE_APP_OL_AK: "7mNuw8pP4VrMFpUPX5L1nwd18Bfy2m8Y",
        VUE_APP_OL_SK: "ABiTQ9rqA1wh03OUz6AbnPRm6IPyQzFu",
        VUE_APP_APPID: "wx0d14b3f957d68955",
        VUE_APP_BRAND: "茶猫",
        VUE_APP_DOWNLOAD: "https://m.teacat.com",
        VUE_APP_COTTI_UA: "teacat",
        VUE_APP_AN_SCHEME: "teacat://link",
        VUE_APP_IOS_SCHEME: "teacatlink://"
    },
    cottiProdEnv: {
        VUE_APP_BASE_API: "https://gateway.cotticoffee.com",
        VUE_APP_MA_BASE_API: "https://ma.cotticoffee.com",
        VUE_APP_AK: "2YAhmad694MnzqmcPQ5X6TJ6EoSx6sYx",
        VUE_APP_SK: "Bu0Zsh4B0SnKBRfds0XWCSn51WJfn5yN",
        VUE_APP_OL_AK: "2YAhmad694MnzqmcPQ5X6TJ6EoSx6sYx",
        VUE_APP_OL_SK: "Bu0Zsh4B0SnKBRfds0XWCSn51WJfn5yN",
        VUE_APP_APPID: "wx0e61bda0c3c34455",
        VUE_APP_BRAND: "COTTI",
        VUE_APP_DOWNLOAD: "https://m.cotticoffee.com",
        VUE_APP_COTTI_UA: "cottiCoffee",
        VUE_APP_AN_SCHEME: "cotticoffee://link",
        VUE_APP_IOS_SCHEME: "cotticoffeelink://"
    }
  }
